import * as React from "react";

export const Plus = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.9999 2.39999C8.33127 2.39999 8.5999 2.66862 8.5999 2.99999V7.39999H12.9999C13.3313 7.39999 13.5999 7.66862 13.5999 7.99999C13.5999 8.33136 13.3313 8.59999 12.9999 8.59999H8.5999V13C8.5999 13.3314 8.33127 13.6 7.9999 13.6C7.66853 13.6 7.3999 13.3314 7.3999 13V8.59999H2.9999C2.66853 8.59999 2.3999 8.33136 2.3999 7.99999C2.3999 7.66862 2.66853 7.39999 2.9999 7.39999H7.3999V2.99999C7.3999 2.66862 7.66853 2.39999 7.9999 2.39999Z"
    />
);
